import './LiveCta.css';
import { tDoor } from '../../copy/door';

export interface LiveCtaProps {
  /** Abre a porta com o formulário de login (a página de antes fica a um "Voltar"). */
  onOpen(): void;
}

/**
 * "Ver ao vivo" (ORD-F-153, complemento de 20/10 20:40): na página inicial e na pré-apuração, para quem não entrou. Leva
 * ao login; depois de entrar, à apuração ao vivo (às 17h00 de 25/10 ela abre sozinha, sem recarregar).
 */
export function LiveCta({ onOpen }: LiveCtaProps) {
  return (
    <button type="button" class="live-cta" data-testid="live-cta" onClick={onOpen}>
      <span class="live-cta__dot" aria-hidden="true" />
      {tDoor('door.cta')}
    </button>
  );
}
